module.exports = __webpack_public_path__ + "static/media/0028.aa0fd710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/RAL/0028.png
// module id = 538
// module chunks = 0